import { entitesSelector } from './root';
import { propNameSelector } from '../utils';

export const goodsEntitiesSelector = propNameSelector(entitesSelector, 'goods');
export const categoriesEntitiesSelector = propNameSelector(entitesSelector, 'categories');
